class PublicOrgService {
    getPublicOrgDetails = async () => {
        return {
            meta: {
                success: true,
                message: 'success',
                code: 200
            },
            data: {
                partnerId: null,
                name: 'Times Engage',
                privacyPolicyUrl: "",
                termAndConditionUrl: "",
                publicName: "Times Engage",
                publicLogo: "https://tml-ad.s3.ap-south-1.amazonaws.com/ac526d81-fe38-11ee-a871-0a71828867bb/timesEngage_crosshair_1788356558106.png",
                publicFavicon: "https://tml-ad.s3.ap-south-1.amazonaws.com/ac526d81-fe38-11ee-a871-0a71828867bb/favI-preview_1788356542831.png",
                publicSmallLogo: "https://tml-ad.s3.ap-south-1.amazonaws.com/ac526d81-fe38-11ee-a871-0a71828867bb/favI-preview_1788356542831.png",
                publicLogoAltText: "Times Engage",
                publicAboutUsUrl: "",
                publicDescription: ""
            }
        }
    }
}

const publicOrgServiceInstance = new PublicOrgService();

export default publicOrgServiceInstance